import React from 'react';
import { observer } from 'mobx-react';
import { BaasicWarningModalTemplate } from 'themes/components';

function BaasicWarningModal(props) {
	return <BaasicWarningModalTemplate {...props} />;
}

export default observer(BaasicWarningModal);



// WEBPACK FOOTER //
// ./src/core/components/dialog/BaasicWarningModal.jsx